(() => {
  'use strict';

  // Add both scoping classes: base (for header/trust cards/shared styles) + product-specific
  document.body.classList.add('shabima-landing-v1-page', 'shabima-protector-v2-page');

  // ── Hide native Shopify add-to-cart (Releasit owns purchase flow) ──
  function hideNativeButtons() {
    document.querySelectorAll('.product-form__submit:not([id*="_rsi"]):not([class*="_rsi"])').forEach(function(btn) {
      btn.style.display = 'none';
    });
    var paymentBtn = document.querySelector('.shopify-payment-button');
    if (paymentBtn) paymentBtn.style.display = 'none';
    // Also hide the variant picker if single variant
    var picker = document.querySelector('variant-selects, variant-radios');
    if (picker && picker.querySelectorAll('input[type="radio"], option').length <= 1) {
      picker.style.display = 'none';
    }
  }
  hideNativeButtons();
  // Observe only during initial app hydration; CSS remains the persistent guard.
  var nativeButtonObserver = new MutationObserver(hideNativeButtons);
  nativeButtonObserver.observe(document.body, {childList: true, subtree: true});
  window.setTimeout(function() { nativeButtonObserver.disconnect(); }, 10000);

  // Product-scoped Releasit branding. It only changes presentation/copy in this DEV template.
  // Quantity, discount, price and variant data remain owned by Releasit quantity offers.
  function applyReleasitBranding() {
    var settings = window._RSI_COD_FORM_SETTINGS;
    if (!settings || !settings.form) return false;

    var rose = 'rgba(183, 123, 133, 1)';
    var blush = 'rgba(228, 185, 194, 1)';
    var porcelain = 'rgba(248, 243, 239, 1)';
    var mocha = 'rgba(52, 39, 37, 1)';
    var alertRed = 'rgba(237, 21, 21, 1)';

    settings.form.header.title = 'Completa tu pedido';
    Object.assign(settings.form.header.titleStyle, {
      color: mocha,
      fontWeight: '700'
    });
    Object.assign(settings.form.style, {
      bgColor: 'rgba(255,255,255,1)',
      borderColor: blush,
      color: mocha,
      shadowOpacity: 0.16
    });
    Object.assign(settings.form.fields.style, {
      bgColor: 'rgba(248,243,239,0.55)',
      borderColor: blush,
      borderRadius: 10,
      shadowOpacity: 0.08
    });
    var itemCopy = {
      'additionals_custom_text.1757898719991': {text: '1. Elige tu oferta', color: rose},
      'custom_text': {text: '2. Completa tus datos de entrega', color: alertRed},
      'phone': {label: 'WhatsApp (10 dígitos)'},
      'first_name': {label: 'Nombre'},
      'last_name': {label: 'Apellido'},
      'province_country_field': {label: 'Departamento'},
      'city': {label: 'Ciudad o municipio'},
      'additionals_custom_text.1766873625876': {
        text: 'Verifica que tu dirección esté completa: incluye barrio y, si aplica, conjunto, torre o apartamento.',
        color: alertRed
      },
      'address': {label: 'Dirección completa'},
      'additionals_text_input.1716864611568': {label: 'Conjunto, torre, apartamento, casa o piso (opcional)'},
      'civic_number': {label: 'Barrio'},
      'additionals_custom_text.1757900278871': {text: '3. Revisa tu pedido', color: rose},
      'additionals_custom_text.1757901382063': {text: '4. Confirma tu compra', color: alertRed},
      'additionals_custom_text.1768586258811': {
        text: '¿Prefieres pagar ahora? Puedes autorizar la entrega en portería, a un vecino o a una persona de confianza. Aceptamos todos los medios de pago y tu compra está protegida.',
        color: mocha
      }
    };
    settings.form.fields.items_array.forEach(function(item) {
      var replacement = itemCopy[item.type];
      if (replacement) Object.assign(item, replacement);
    });

    var quantityOffers = window._RSI_COD_FORM_QUANTIY_OFFERS;
    if (Array.isArray(quantityOffers)) {
      var protectorOffers = quantityOffers.find(function(group) {
        return Array.isArray(group.pIds) && group.pIds.indexOf('8895808798917') !== -1;
      });
      if (protectorOffers) {
        protectorOffers.selBC = rose;
        protectorOffers.selBgC = 'rgba(228,185,194,0.28)';
        protectorOffers.prSize = 15;
        var offerOne = protectorOffers.offers && protectorOffers.offers.find(function(x) { return x.qty === 1; });
        var offerTwo = protectorOffers.offers && protectorOffers.offers.find(function(x) { return x.qty === 2; });
        if (offerOne) Object.assign(offerOne, {
          title: '1 Protector Solar Serum 10 · 110 g',
          plaque: 'Opción individual',
          plaqueBgC: rose,
          plaqueTC: porcelain,
          prC: mocha
        });
        if (offerTwo) Object.assign(offerTwo, {
          title: '2 Protectores Solares Serum 10 · 110 g c/u',
          plaque: 'Mayor ahorro',
          plaqueBgC: mocha,
          plaqueTC: porcelain,
          prC: mocha
        });
      }
    }
    return true;
  }

  var releasitBrandAttempts = 0;
  var releasitBrandTimer = window.setInterval(function() {
    releasitBrandAttempts += 1;
    if (applyReleasitBranding() || releasitBrandAttempts >= 100) {
      window.clearInterval(releasitBrandTimer);
    }
  }, 100);

  // If Releasit rendered before its config was branded, update only matching text nodes.
  var releasitCopyMap = {
    'Completa tu Orden Aquí👇': 'Completa tu pedido',
    '1- Elige tu Oferta👇': '1. Elige tu oferta',
    '2- Escribe correctamente tus datos de Envío👇': '2. Completa tus datos de entrega',
    'NÚMERO WHATSAPP (Verifica que este bien escrito)': 'WhatsApp (10 dígitos)',
    'NOMBRE': 'Nombre',
    'APELLIDO': 'Apellido',
    'DEPARTAMENTO': 'Departamento',
    'CIUDAD O MUNICIPIO': 'Ciudad o municipio',
    '⛔ 9 de cada 10 pedidos que no llegan es por que la dirección no esta completa, falta el barrio o el nombre de conjunto o # de apto. ¿Ya revisaste la tuya?': 'Verifica que tu dirección esté completa: incluye barrio y, si aplica, conjunto, torre o apartamento.',
    'Dirección Ej: Calle/Cr/Trans 12 # 24 -54': 'Dirección completa',
    'Nombre del CONJUNTO, TORRE, APTO, CASA, PISO': 'Conjunto, torre, apartamento, casa o piso (opcional)',
    'Escribe el Nombre del Barrio': 'Barrio',
    '3 - Resumen del Pedido👇': '3. Revisa tu pedido',
    '4 - Confirma tu Compra👇': '4. Confirma tu compra',
    '1 Protector Solares 110g': '1 Protector Solar Serum 10 · 110 g',
    '2 Protectores Solar 110g c/u': '2 Protectores Solares Serum 10 · 110 g c/u',
    'Oferta Especial': 'Opción individual',
    'Más Ahorro': 'Mayor ahorro'
  };
  function applyRenderedReleasitCopy() {
    var modal = document.getElementById('_rsi-cod-form-modal');
    if (!modal) return;
    var walker = document.createTreeWalker(modal, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var key = node.nodeValue.trim();
      if (releasitCopyMap[key]) node.nodeValue = node.nodeValue.replace(key, releasitCopyMap[key]);
    }
  }
  var releasitModalObserver = new MutationObserver(applyRenderedReleasitCopy);
  releasitModalObserver.observe(document.body, {childList: true, subtree: true});
  window.setTimeout(function() { releasitModalObserver.disconnect(); }, 30000);

  // Touch-swipe support for the product gallery carousel (improves mobile UX).
  const gallery = document.querySelector('.product__media-list');
  if (gallery) {
    let startX = 0;
    gallery.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) < 40) return;
      const btn = dx < 0
        ? document.querySelector('.slider-button--next')
        : document.querySelector('.slider-button--prev');
      if (btn) btn.click();
    }, { passive: true });
  }
})();
